import { render, staticRenderFns } from "./main-logo.vue?vue&type=template&id=0e272f54"
import script from "./main-logo.vue?vue&type=script&lang=js"
export * from "./main-logo.vue?vue&type=script&lang=js"
import style0 from "./main-logo.vue?vue&type=style&index=0&id=0e272f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports